import * as React from "react";

export function WhatsappP(props) {
  return (
    <svg
      width={30}
      height={30}
      viewBox="0 0 30 30"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_333_22)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.732 21.182c-.362 1.023-1.799 1.87-2.945 2.117-.784.167-1.807.298-5.254-1.13-3.872-1.604-9.248-7.318-9.248-11.12 0-1.935 1.116-4.19 3.067-4.19.94 0 1.146.02 1.455.76.362.874 1.244 3.025 1.349 3.246.433.905-.441 1.434-1.075 2.222-.203.237-.432.493-.176.934.255.433 1.137 1.87 2.433 3.024 1.674 1.491 3.031 1.967 3.518 2.17.361.15.793.115 1.057-.167.334-.361.75-.961 1.173-1.553.299-.423.678-.476 1.076-.326.268.093 3.68 1.678 3.825 1.932.106.184.106 1.057-.255 2.08zM15.003 0h-.008C6.726 0 0 6.728 0 15c0 3.28 1.058 6.323 2.856 8.791L.987 29.365l5.765-1.842A14.884 14.884 0 0015.003 30C23.273 30 30 23.272 30 15S23.273 0 15.003 0z"
          fill="currentColor"
          fillOpacity={0.6}
        />
      </g>
      <defs>
        <clipPath id="clip0_333_22">
          <path fill="currentColor" d="M0 0H30V30H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
